var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcondelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 17C9.33579 17 9 16.6642 9 16.25V10.75C9 10.3358 9.33579 10 9.75 10H10.25C10.6642 10 11 10.3358 11 10.75V16.25C11 16.6642 10.6642 17 10.25 17H9.75Z",
    fill: "#3B5118"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 17C13.3358 17 13 16.6642 13 16.25V10.75C13 10.3358 13.3358 10 13.75 10H14.25C14.6642 10 15 10.3358 15 10.75V16.25C15 16.6642 14.6642 17 14.25 17H13.75Z",
    fill: "#3B5118"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3C8.34315 3 7 4.34315 7 6H3.75C3.33579 6 3 6.33579 3 6.75V7.25C3 7.66421 3.33579 8 3.75 8H5V17C5 19.2091 6.79086 21 9 21H15C17.2091 21 19 19.2091 19 17V8H20.25C20.6642 8 21 7.66421 21 7.25V6.75C21 6.33579 20.6642 6 20.25 6H17C17 4.34315 15.6569 3 14 3H10ZM15 6C15 5.44772 14.5523 5 14 5H10C9.44772 5 9 5.44772 9 6H15ZM7 8V17C7 18.1046 7.89543 19 9 19H15C16.1046 19 17 18.1046 17 17V8H7Z",
    fill: "#3B5118"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcondelete);
export default __webpack_public_path__ + "static/media/icon.delete.9d1922b912a2d5b79f1052082c59ea22.svg";
export { ForwardRef as ReactComponent };